import React, { Component } from "react";
import { FiExternalLink } from "react-icons/fi";
import yspanorImage from "../../assets/images/portfolio/modern/yspanor.jpg";
import matisWebsiteImage from "../../assets/images/portfolio/modern/matis-website.jpg";
import matisExperienceImage from "../../assets/images/portfolio/modern/matis-experience.jpg";
import homeOfManagementImage from "../../assets/images/portfolio/modern/home-of-management-ai-bg.jpg";
import codexToolingImage from "../../assets/images/portfolio/modern/codex-tooling-ai-bg.jpg";
import devOffersImage from "../../assets/images/portfolio/modern/dev-offers-ai-bg.jpg";
import pigmentIdImage from "../../assets/images/portfolio/modern/pigment-id.jpg";
import givaudanImage from "../../assets/images/portfolio/modern/givaudan-carto.jpg";
import etherThreeImage from "../../assets/images/portfolio/ETH_logo.png";

const PortfolioListContent = [
    {
        image: codexToolingImage,
        group: 'AI',
        category: 'AI Workflow Infrastructure',
        title: 'Codex Tooling & Custom Skills',
        description:'A service catalog and source-of-truth repo for custom Codex skills, reusable agent workflows, GitHub setup, web app templates, and Three.js creation flows.',
        tags: ['Codex', 'Skills', 'Agents'],
        href: 'https://codex-tooling.vercel.app/'
    },
    {
        image: devOffersImage,
        group: 'AI',
        category: 'AI Agent Job Search',
        title: 'Dev Offers',
        description:'Personal freelance command center that ingests job alerts, normalizes offers, deduplicates them, scores freelance fit, and keeps final applications manual.',
        tags: ['Agents', 'Scoring', 'Automation'],
        href: 'https://dev-offers.vercel.app/'
    },
    {
        image: matisWebsiteImage,
        group: 'Art-tech',
        category: 'Art-tech Product Website',
        title: 'MATIS Website',
        description:'Modern product site for a multispectral art-analysis platform, presenting spectral bands, image-processing UI, hardware details, and 3D gallery entry points.',
        tags: ['Product site', 'Imaging', 'UX'],
        href: 'https://matis-website.vercel.app/'
    },
    {
        image: matisExperienceImage,
        group: '3D',
        category: '3D / React Three Fiber',
        title: 'MATIS Experience',
        description:'Memory-intensive 3D painting modelisation experience built with React Three Fiber and Three.js to explore visible, UV, and IR image layers.',
        tags: ['Three.js', 'R3F', '3D art'],
        href: 'https://matis-experience-react-dev.vercel.app/'
    },
    {
        image: homeOfManagementImage,
        group: 'Product',
        category: 'Leadership Platform',
        title: 'Home of Management',
        description:'Membership and mentoring platform for managers who want sustainable performance, leadership practice, training, tools, and community without burnout.',
        tags: ['Next.js', 'Community', 'CMS'],
        href: 'https://www.homeofmanagement.com/'
    },
    {
        image: yspanorImage,
        group: 'Product',
        category: 'Game IP / Interactive Website',
        title: 'Yspanor',
        description:'Dark fantasy strategy universe and Next.js website for a board-game/digital prototype with hidden Orders, factions, influence, and a future AI opponent.',
        tags: ['Game IP', 'Next.js', 'Lore'],
        href: 'https://www.yspanor.com/'
    },
    {
        image: etherThreeImage,
        group: 'Web3',
        category: 'Web3 / Three.js',
        title: 'Ether Three.js',
        description:'Interactive Web3 experiment combining Ethereum UI concepts, Solidity learning, Ethers.js integration, and Three.js visuals for a browser-based crypto interface.',
        tags: ['Solidity', 'Ethers.js', 'Three.js'],
        href: 'https://etherthree-js.vercel.app/'
    },
    {
        image: pigmentIdImage,
        group: 'AI',
        category: 'AI-assisted Art Analysis',
        title: 'Pigment ID Mobile',
        description:'Expo and React Native prototype for pigment identification workflows around MATIS imaging, connecting art analysis UX with mobile capture and interpretation.',
        tags: ['Expo', 'Mobile', 'Art AI'],
        href: 'https://matis.art/'
    },
    {
        image: givaudanImage,
        group: 'Data',
        category: 'Internal Product / Data Viz',
        title: 'Givaudan Perfumery Tools',
        description:'Large-scale React, Node, and D3 perfumer workflow apps, including global MVPs, semantic zoom benchmark maps, live samples, and AI-assisted prototypes.',
        tags: ['D3.js', 'React', 'Enterprise'],
        href: 'https://www.givaudan.com/fragrance-beauty/perfumery-school/carto-the-future-of-fragrance-formulations'
    }
]

const PortfolioFilters = ['All', 'AI', 'Art-tech', '3D', 'Product', 'Web3', 'Data'];

class PortfolioList extends Component{
    constructor(props) {
        super(props);
        this.state = {
            activeFilter: 'All'
        };
    }

    setFilter = (activeFilter) => {
        this.setState({ activeFilter });
    }

    handleFilterClick = (event, filter) => {
        const button = event.currentTarget;

        this.setFilter(filter);

        if (window.innerWidth > 767) {
            return;
        }

        window.requestAnimationFrame(() => {
            button.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center'
            });
        });
    }

    render(){
        const {column , styevariation } = this.props;
        const list = PortfolioListContent.slice(0 , this.props.item);
        const { activeFilter } = this.state;
        const filteredList = activeFilter === 'All'
            ? list
            : list.filter((value) => value.group === activeFilter);

        return(
            <React.Fragment>
                <div className="col-12">
                    <div className="portfolio-filter-shell" aria-label="Project filters">
                        <div className="portfolio-filter-copy">
                            <span>Filter the work</span>
                            <strong>{filteredList.length} of {list.length} projects</strong>
                        </div>
                        <div className="portfolio-filter-bar">
                            {PortfolioFilters.map((filter) => {
                                const count = filter === 'All'
                                    ? list.length
                                    : list.filter((value) => value.group === filter).length;

                                if (!count) {
                                    return null;
                                }

                                return (
                                    <button
                                        type="button"
                                        className={`portfolio-filter-button ${activeFilter === filter ? 'is-active' : ''}`}
                                        onClick={(event) => this.handleFilterClick(event, filter)}
                                        aria-pressed={activeFilter === filter}
                                        key={filter}
                                    >
                                        <span>{filter}</span>
                                        <em>{count}</em>
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <div className="row portfolio-grid-lock">
                        {filteredList.map((value , index) => (
                            <div className={`${column}`} key={value.title}>
                                <div
                                    className={`portfolio portfolio-card-modern ${styevariation}`}
                                    style={{ '--project-index': index }}
                                >
                                    <div className="thumbnail-inner">
                                        <div className="thumbnail" style={{ backgroundImage: `url(${value.image})` }}></div>
                                        <div className="bg-blr-image" style={{ backgroundImage: `url(${value.image})` }}></div>
                                    </div>
                                    <div className="content">
                                        <div className="inner">
                                            <div className="project-card-topline">
                                                <h3>{value.category}</h3>
                                                <a
                                                    className="project-card-link-hint"
                                                    href={value.href}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    aria-label={`Open ${value.title}`}
                                                >
                                                    <FiExternalLink />
                                                    Open
                                                </a>
                                            </div>
                                            <h6>{value.title}</h6>
                                            <p>{value.description}</p>
                                            <ul className="project-tags" aria-label={`${value.title} stack`}>
                                                {value.tags.map((tag) => (
                                                    <li key={tag}>{tag}</li>
                                                ))}
                                            </ul>
                                            <div className="portfolio-button">
                                                <a className="rn-btn" href={value.href} target="_blank" rel="noreferrer">View Project</a>
                                            </div>
                                        </div>
                                    </div>
                                    <a className="link-overlay" href={value.href} target="_blank" rel="noreferrer" aria-label={`Open ${value.title}`}></a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            </React.Fragment>
        )
    }
}
export default PortfolioList;
